// Respaldo (7.3j): lee todas las tablas y arma el Excel. Lo que se descarga queda en el computador de quien lo pide.
import type { SupabaseClient } from '@supabase/supabase-js';
import { guardarParametro } from './ajustes';
import { todas } from './pedidos';
import { hojaDeTabla, hojaLeeme, TABLAS_RESPALDO } from '../logica/respaldo';
import { libroExcel } from '../logica/xlsx';

export interface Respaldo { libro: Uint8Array; hojas: number; filas: number }

export async function generarRespaldo(sb: SupabaseClient, fecha: string, ambiente: string): Promise<Respaldo> {
  const leidas = await Promise.all(TABLAS_RESPALDO.map(async ({ t, o }) => ({
    t, filas: await todas<Record<string, unknown>>((a, b) => { let q = sb.from(t).select('*'); for (const c of o) q = q.order(c, { ascending: true }); return q.range(a, b); }),
  })));
  const conteos = leidas.map(x => [x.t, x.filas.length] as [string, number]);
  return { libro: libroExcel([hojaLeeme(fecha, ambiente, conteos), ...leidas.map(x => hojaDeTabla(x.t, x.filas))]), hojas: leidas.length + 1, filas: conteos.reduce((s, c) => s + c[1], 0) };
}

export async function ultimoRespaldo(sb: SupabaseClient): Promise<string | null> {
  const { data, error } = await sb.from('parametros').select('valor').eq('clave', 'ultimo_respaldo').maybeSingle();
  if (error) throw new Error(error.message);
  return (data?.valor as { fecha?: string } | null)?.fecha || null;
}
export const marcarRespaldo = (sb: SupabaseClient, fecha: string) => guardarParametro(sb, 'ultimo_respaldo', { fecha });
